import React from "react";
import { NumericFormat, PatternFormat } from "react-number-format";
import {
  Button,
  Modal,
  Select,
  Textfield,
} from "../../../../../components/core";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@apollo/client";
import { DOOR_SIZES } from "../../../../../constants/graphql/global-queries";
import { setDoorSizesList } from "../../../../../features/locker-fees/add-partner-fees/add-partner-fees-slice";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Row } from "primereact/row";
import { ColumnGroup } from "primereact/columngroup";

export default function DropoffCostTable({
  items = [],
  lockerType,
  partnerType,
  addedData,
  handleAddDataItem,
  handleModifyAddedItems,
  handleModifyDataItems,
  disabled = false,
  pulloutHours = 0,
}) {
  console.log({ addedData, items });
  const dispatch = useDispatch();
  const doorSizes = useQuery(DOOR_SIZES);
  const doorSizesList = useSelector(
    (state) => state.addPartnerFee.doorSizesList
  );
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  React.useEffect(() => {
    if (doorSizes.data) {
      let tempVar = [];
      doorSizes.data.doorSizes.map((element) => {
        tempVar.push({
          value: element.doorSizeId,
          name: element.doorSize,
        });
      });
      dispatch(setDoorSizesList(tempVar));
    }
  }, [doorSizes.data]);

  // Combine items and addedData for the table
  const allData = [
    ...items.map((item, idx) => ({
      ...item,
      _id: `item-${idx}`,
      _type: "existing",
    })),
    ...(addedData || []).map((item, idx) => ({
      ...item,
      _id: `added-${idx}`,
      _type: "added",
    })),
  ];

  // Template for Door Size column
  const doorSizeTemplate = (rowData) => {
    const index =
      rowData._type === "existing"
        ? parseInt(rowData._id.split("-")[1])
        : parseInt(rowData._id.split("-")[1]);
    const handler =
      rowData._type === "existing"
        ? handleModifyDataItems
        : handleModifyAddedItems;

    return (
      <Select
        disabled={disabled && rowData._type === "existing"}
        name="doorSizeId"
        id={index}
        value={rowData.doorSizeId}
        items={doorSizesList}
        onChange={handler}
      />
    );
  };

  // Template for Dropoff Fee column
  const dropoffFeeTemplate = (rowData) => {
    const index =
      rowData._type === "existing"
        ? parseInt(rowData._id.split("-")[1])
        : parseInt(rowData._id.split("-")[1]);
    const handler =
      rowData._type === "existing"
        ? handleModifyDataItems
        : handleModifyAddedItems;

    return (
      <div className="flex gap-2">
        <Textfield
          disabled={disabled && rowData._type === "existing"}
          placeholder="0.00"
          prefix={`₱`}
          value={rowData.dropoffFee}
          name="dropoffFee"
          id={index}
          onChange={(e) => {
            var numberPattern = /^\d+(\.\d{0,2})?$/;
            if (numberPattern.test(e.target.value) || e.target.value === "") {
              if (
                parseFloat(e.target.value) <= 1000000000 ||
                e.target.value === ""
              )
                handler(e);
            }
          }}
        />
      </div>
    );
  };

  // Template for Initial Free Hours column
  const initialFreeHoursTemplate = (rowData) => {
    const index =
      rowData._type === "existing"
        ? parseInt(rowData._id.split("-")[1])
        : parseInt(rowData._id.split("-")[1]);
    const handler =
      rowData._type === "existing"
        ? handleModifyDataItems
        : handleModifyAddedItems;

    return (
      <div className="flex gap-2">
        <Textfield
          disabled={disabled && rowData._type === "existing"}
          placeholder="XXX"
          value={rowData.initialFreeHours}
          name="initialFreeHours"
          id={index}
          onChange={(e) => {
            var numberPattern = /^(\d+)?$/;
            if (
              numberPattern.test(e.target.value) &&
              (parseFloat(e.target.value) <= 720 || e.target.value === "")
            ) {
              handler(e);
            }
          }}
        />
        <p className="my-auto">hrs</p>
      </div>
    );
  };

  // // Template for Initial Free Hours column
  // const pullOutHoursTemplate = (rowData) => {
  //   console.log({ PULLOUT: rowData });
  //   const index =
  //     rowData._type === "existing"
  //       ? parseInt(rowData._id.split("-")[1])
  //       : parseInt(rowData._id.split("-")[1]);
  //   const handler =
  //     rowData._type === "existing"
  //       ? handleModifyDataItems
  //       : handleModifyAddedItems;

  //   return (
  //     <div className="flex gap-2">
  //       <Textfield
  //         disabled={disabled && rowData._type === "existing"}
  //         placeholder="XXX"
  //         value={rowData.initialFreeHours}
  //         name="initialFreeHours"
  //         id={index}
  //         onChange={(e) => {
  //           var numberPattern = /^(\d+)?$/;
  //           if (
  //             numberPattern.test(e.target.value) &&
  //             (parseFloat(e.target.value) <= 720 || e.target.value === "")
  //           ) {
  //             handler(e);
  //           }
  //         }}
  //       />
  //       <p className="my-auto">hrs</p>
  //     </div>
  //   );
  // };

  // Template for RTS Fee column
  const rtsFeeTemplate = (rowData) => {
    const index =
      rowData._type === "existing"
        ? parseInt(rowData._id.split("-")[1])
        : parseInt(rowData._id.split("-")[1]);
    const handler =
      rowData._type === "existing"
        ? handleModifyDataItems
        : handleModifyAddedItems;

    return (
      <div className="flex gap-2">
        <Textfield
          disabled={disabled && rowData._type === "existing"}
          placeholder="0.00"
          prefix={`₱`}
          value={rowData.rtsFee}
          name="rtsFee"
          id={index}
          onChange={(e) => {
            var numberPattern = /^\d+(\.\d{0,2})?$/;
            if (numberPattern.test(e.target.value) || e.target.value === "") {
              if (
                parseFloat(e.target.value) <= 1000000000 ||
                e.target.value === ""
              )
                handler(e);
            }
          }}
        />
      </div>
    );
  };

  // Template for RTS Overstay Charges column
  const rtsOverstayChargesTemplate = (rowData) => {
    const index =
      rowData._type === "existing"
        ? parseInt(rowData._id.split("-")[1])
        : parseInt(rowData._id.split("-")[1]);
    const handler =
      rowData._type === "existing"
        ? handleModifyDataItems
        : handleModifyAddedItems;

    // Validated handler for rtsOverstayRate
    const handleRtsOverstayRateChange = (e) => {
      const numberPattern = /^\d+(\.\d{0,2})?$/;
      if (numberPattern.test(e.target.value) || e.target.value === "") {
        if (parseFloat(e.target.value) <= 1000000000 || e.target.value === "") {
          handler(e);
        }
      }
    };

    // Validated handler for rtsOverstayUnitHours
    const handleRtsOverstayUnitHoursChange = (e) => {
      const numberPattern = /^(\d+)?$/;
      if (
        numberPattern.test(e.target.value) &&
        (parseFloat(e.target.value) <= 720 || e.target.value === "")
      ) {
        handler(e);
      }
    };

    return (
      <>
        <div className="flex gap-2">
          <Textfield
            disabled={disabled}
            prefix={`₱`}
            value={rowData.rtsOverstayRate}
            placeholder="0.00"
            name="rtsOverstayRate"
            id={index}
            onChange={handleRtsOverstayRateChange}
          />{" "}
          <p className="my-auto"> / </p>
          <p className="my-auto">every</p>{" "}
          <Textfield
            disabled={disabled}
            placeholder="XXX"
            value={rowData.rtsOverstayUnitHours}
            name="rtsOverstayUnitHours"
            id={index}
            onChange={handleRtsOverstayUnitHoursChange}
          />
          <p className="my-auto">hrs</p>
        </div>
      </>
    );
  };

  // Template for RTS Max Overstay Charge column
  const rtsOverstayMaxFeeTemplate = (rowData) => {
    const index =
      rowData._type === "existing"
        ? parseInt(rowData._id.split("-")[1])
        : parseInt(rowData._id.split("-")[1]);
    const handler =
      rowData._type === "existing"
        ? handleModifyDataItems
        : handleModifyAddedItems;

    return (
      <div className="flex gap-2">
        <Textfield
          prefix={`₱`}
          disabled={disabled && rowData._type === "existing"}
          placeholder="0.00"
          value={rowData.rtsOverstayMaxFee}
          name="rtsOverstayMaxFee"
          id={index}
          onChange={(e) => {
            var numberPattern = /^\d+(\.\d{0,2})?$/;
            if (numberPattern.test(e.target.value) || e.target.value === "") {
              if (
                parseFloat(e.target.value) <= 1000000000 ||
                e.target.value === ""
              )
                handler(e);
            }
          }}
        />
      </div>
    );
  };

  // Custom header template for grouped columns
  const dropoffCostHeader = (
    <div className="text-center">
      <div className="font-bold text-lg">DROPOFF COST</div>
      <div className="text-sm">
        for {lockerType} Locker - {partnerType} Partner
      </div>
    </div>
  );

  const rtsFeeHeader = (
    <div className="text-center">
      <div className="font-bold text-lg">RTS FEE</div>
      <div className="text-sm">
        for {lockerType} Locker - {partnerType} Partner
      </div>
    </div>
  );

  const headerColumnGroup = (
    <ColumnGroup>
      <Row>
        <Column
          header="DOOR SIZE"
          rowSpan={2}
          alignHeader={"center"}
          headerClassName="tracking-wide bg-primary-primaryYellow text-secondary-purpleGray border"
        />
        <Column
          header="PARTNER DROPOFF COST"
          rowSpan={1}
          colSpan={2}
          headerClassName="tracking-wide bg-primary-primaryYellow text-secondary-purpleGray border"
          alignHeader={"center"}
        />
        {/* <Column
          header="PARTNER PULLOUT LIMIT"
          rowSpan={2}
          headerClassName="tracking-wide bg-primary-primaryYellow text-secondary-purpleGray border"
          alignHeader={"center"}
        /> */}
        <Column
          header={`PARTNER RTS COST `}
          rowSpan={1}
          colSpan={3}
          alignHeader={"center"}
          headerClassName="tracking-wide bg-primary-primaryYellow text-secondary-purpleGray border"
        />
      </Row>
      <Row>
        <Column
          header="Dropoff Fee"
          rowSpan={1}
          alignHeader={"center"}
          headerClassName="bg-primary-primaryYellow text-secondary-purpleGray border"
        />
        <Column
          header="Initial Free Hours"
          rowSpan={1}
          alignHeader={"center"}
          headerClassName="bg-primary-primaryYellow text-secondary-purpleGray border"
        />
        {/* <Column
          header="Pullout Limit"
          rowSpan={1}
          alignHeader={"center"}
          headerClassName="bg-primary-primaryYellow text-secondary-purpleGray border"
        /> */}
        <Column
          header="RTS Fee"
          rowSpan={1}
          alignHeader={"center"}
          headerClassName="bg-primary-primaryYellow text-secondary-purpleGray border"
        />
        <Column
          header={`RTS Overstay Charges (${pulloutHours}hrs after RTS Alert)`}
          rowSpan={1}
          alignHeader={"center"}
          headerClassName="bg-primary-primaryYellow text-secondary-purpleGray border"
        />
        <Column
          header="RTS Max. Overstay Charge"
          rowSpan={1}
          alignHeader={"center"}
          headerClassName="bg-primary-primaryYellow text-secondary-purpleGray border"
        />
        {/* <Column
          header=""
          rowSpan={1}
          alignHeader={"center"}
          headerClassName="bg-primary-primaryYellow text-secondary-purpleGray border"
        /> */}
      </Row>
    </ColumnGroup>
  );
  return (
    <>
      <Card>
        <div className="my-4 text-black">
          <DataTable
            value={allData}
            stripedRows
            className="border-2 border-gray-400"
            rowClassName="h-12"
            headerColumnGroup={headerColumnGroup}
          >
            <Column
              field="doorSizeId"
              className="border"
              body={doorSizeTemplate}
              headerClassName="bg-primary-primaryYellowLight font-bold text-lg"
              style={{ width: "9rem" }}
            />

            <Column
              field="dropoffFee"
              className="border"
              body={dropoffFeeTemplate}
              headerClassName="bg-primary-primaryYellowLight font-bold text-lg"
              style={{ width: "9rem" }}
            />

            <Column
              field="initialFreeHours"
              className="border"
              body={initialFreeHoursTemplate}
              headerClassName="bg-primary-primaryYellowLight font-bold text-lg"
              style={{ width: "9rem" }}
            />
            {/* <Column
              field="initialFreeHours"
              className="border"
              body={pullOutHoursTemplate}
              headerClassName="bg-primary-primaryYellowLight font-bold text-lg"
              style={{ width: "9rem" }}
            /> */}

            <Column
              field="rtsFee"
              className="border"
              body={rtsFeeTemplate}
              headerClassName="bg-primary-primaryYellowLight font-bold text-lg"
              style={{ width: "9rem" }}
            />
            <Column
              field="rtsOverstayCharge"
              className="border"
              body={rtsOverstayChargesTemplate}
              headerClassName="bg-primary-primaryYellowLight font-bold text-lg"
              style={{ width: "12rem" }}
            />

            <Column
              field="rtsMaxFee"
              className="border"
              body={rtsOverstayMaxFeeTemplate}
              headerClassName="bg-primary-primaryYellowLight font-bold text-lg"
              style={{ width: "9rem" }}
            />
          </DataTable>

          {/* Add Button - Fixed to not float */}
          <div className="mt-4">
            <Button
              className={"p-4"}
              disabled={disabled}
              value={"Add"}
              onClick={() => {
                let combinedDataAndAddedData = [
                  ...(addedData || []),
                  ...(items ? items : []),
                ];
                if (combinedDataAndAddedData.length === doorSizesList.length) {
                  setValidation({
                    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                    title: "Error",
                    message: "Maximum number of door size is reached",
                    open: true,
                    actions: (
                      <div className="grid grid-cols-1">
                        <Button
                          onClick={() => setValidation({ open: false })}
                          value={"OK"}
                          className={"p-2"}
                        />
                      </div>
                    ),
                  });
                } else {
                  handleAddDataItem();
                }
              }}
            />
          </div>
        </div>
      </Card>

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </>
  );
}
